import { EuiListGroupItem, EuiIcon } from "@elastic/eui"
import Flag from 'react-flagkit';
import React,{ useMemo } from "react";
import { CreateFecha } from "../../../../../shared/utils/fecha";

export const ItemList = (props:any) =>{

    const {data, onClickItem, actions, onRemoveItem, active} = props;
    
    const onClick = ()=>{
        onClickItem(data)
    }

    const getRemoveAction = ():any =>{
        if(onRemoveItem){
            return {
                color: 'danger',
                onClick: ()=> onRemoveItem(data),
                iconType: 'crossInACircleFilled',
                iconSize: 's',
                'aria-label': 'Eliminar centro',
                alwaysShow: true
                }
        }else{return {}}
    }

    const getPais = () => (<Flag country={data.codPais} /> || undefined);

    const getFechaBajaLabel = () => `${data.fechaBaja!==null ? '(Baja desde el '+ CreateFecha(data.fechaBaja) + ')' : ''}`
    
    const getLabel = () =>(<p>{data.label} <strong className="strongFechaBaja">{getFechaBajaLabel()}</strong></p>)

    return <EuiListGroupItem 
    isDisabled={ active }
    label={getLabel()}
    extraAction={getRemoveAction()}
    iconType={getPais} 
    size='s'
    onClick={()=> !actions && onClick()}/>
}